// extracted by mini-css-extract-plugin
module.exports =  {"prefix":"GR1q8bqRBv0NDP9syWcA"};